const production = process.env.VUE_APP_PRODUCTION;
const URL_FILE = process.env.VUE_APP_URL_FILE;
const URL_FILE_DEV = process.env.VUE_APP_URL_FILE_DEV;
export const URL_GED = production === "FALSE" ? URL_FILE_DEV : URL_FILE;

export const URL_GED_FICHIER = URL_GED + "api/fichiers/";

export const URL_API = "api/entites/";

export const PATH_PDF = "/static/appli/pdfjs-2.9.359-dist/web/viewer.html";
export const MAX_PAGE = 200;

export const DR_TEST_CHD = ["PA11", "MPL", "DGE", "LYS"];
export const DR_TEST_COMMENTAIRE = ["PA11", "MPL", "LYS"];

export const MAX_ELEM_IN_SHOW = 500;
